import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import WizardLayout from './WizardLayout';
import AuthWizardProvider from './AuthWizardProvider';

const Wizard = ({
  variant,
  validation,
  progressBar,
  signupType = 'individual'
}) => {
  const { pathname } = useLocation();
  const resolvedSignupType =
    signupType === 'organization' || pathname.endsWith('/signup/org')
      ? 'organization'
      : 'individual';

  return (
    <AuthWizardProvider>
      <WizardLayout
        variant={variant}
        validation={validation}
        progressBar={progressBar}
        signupType={resolvedSignupType}
      />
    </AuthWizardProvider>
  );
};

Wizard.propTypes = {
  variant: PropTypes.oneOf(['pills']),
  validation: PropTypes.bool,
  progressBar: PropTypes.bool,
  signupType: PropTypes.oneOf(['individual', 'organization'])
};

export default Wizard;
